var map = {
	"./inner-360-factory-visibility.svg": "./src/assets/img/training-card/inner-360-factory-visibility.svg",
	"./inner-automated-material-flow.svg": "./src/assets/img/training-card/inner-automated-material-flow.svg",
	"./inner-course-symb.png": "./src/assets/img/training-card/inner-course-symb.png",
	"./inner-course-symb.svg": "./src/assets/img/training-card/inner-course-symb.svg",
	"./inner-data-driven-maintenance.svg": "./src/assets/img/training-card/inner-data-driven-maintenance.svg",
	"./inner-digital-organization.svg": "./src/assets/img/training-card/inner-digital-organization.svg",
	"./inner-digital-ready-infrastructure.svg": "./src/assets/img/training-card/inner-digital-ready-infrastructure.svg",
	"./inner-fof-leadership.svg": "./src/assets/img/training-card/inner-fof-leadership.svg",
	"./inner-intelligent-quality.svg": "./src/assets/img/training-card/inner-intelligent-quality.svg",
	"./inner-sustainability.svg": "./src/assets/img/training-card/inner-sustainability.svg",
	"./inner-tech-augmented-workforce.svg": "./src/assets/img/training-card/inner-tech-augmented-workforce.svg",
	"./inner-zero-touches-production.svg": "./src/assets/img/training-card/inner-zero-touches-production.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/training-card sync recursive ^\\.\\/inner\\-.*$";